module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/wizard_mobile-4e49cfe9bf590bad75d25611db0e34dd.png";